import {useRef, useState} from 'react';

export interface UseWarningModal {
    open: boolean;
    onOpen: (callback: () => void) => void;
    onCancel: () => void;
    onConfirm: () => void;
}

const useWarningModal = (): UseWarningModal => {
    const [open, setOpen] = useState<boolean>(false);
    const callbackRef = useRef<() => void | null>(null);

    const close = () => {
        setOpen(false);
        callbackRef.current = null;
    };

    const handleConfirm = () => {
        callbackRef.current();
        close();
    };

    const handleOpen = callback => {
        callbackRef.current = callback;
        setOpen(true);
    };

    return {
        open,
        onOpen: handleOpen,
        onCancel: close,
        onConfirm: handleConfirm
    };
};

export default useWarningModal;
